// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"jL-z","carouselContainer":"kL-z"};